import { getAuth0Instance } from '@my-prtg-com/shared/src/auth0'
import store from '@/store'

const supporterGuard = (to, from, next) => {
  const user = getAuth0Instance().normalizedUser
  if (user.roles.includes('supporter')) {
    return next()
  }
  return next('/')
}

const manageGuard = ({ params: { id } }, from, next) => {
  store.dispatch('subscription/checkIfExists', id)
    .then(() => next())
    .catch(() => next('/'))
}

const signupGuard = () => {
  const authService = getAuth0Instance()

  authService.$watch('isReady', isReady => {
    if (isReady) {
      return getAuth0Instance().signupWithRedirect()
    }
  })
}

export {
  supporterGuard,
  manageGuard,
  signupGuard,
}
